import { Drawer } from 'antd';
import styled from 'styled-components';

export const BottomSectionWrapper = styled.div`
  .table-container {
    width: 488px;
    height: 250px;
    margin-top: 8px;
    overflow: hidden !important;
  }
  .date-time-wrapper {
    display: flex;
    flex-direction: column;
    grid-row-gap: 0px;
    span {
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #535E63;
    &:not(:first-child){
      font-size: 9px;
      color: #7E8A90;
      font-weight: 400;
    }
}
}
  .table-title {
    font-size: 18px;
    font-weight: bold;
    color: #2563eb; /* Blue color for title */
    margin-bottom: 12px;
    display: inline-block;
  }
  thead {
    position: sticky; /* Make the header sticky */
    top: 0; /* Stick the header to the top of the container */
    z-index: 2; /* Ensure the header stays on top of scrolling content */
  }
  .custom-table {
    display: block;
    max-height: 250px !important;
    overflow: scroll;
    scrollbar-width: none;
    -ms-overflow-style: none;
    padding-bottom: 28px;
    width: 100%;
    table-layout: fixed;
  }
  .no-data {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 172px;
    color: #808183;
    font-size: 12px ;
    font-family: 'Titillium Web';
    font-weight: 600;
  }
  .custom-table th {
    box-sizing: border-box;
    background-color: #f8fafb;
    font-family: Titillium Web;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    color: #808183;
    padding: 8px 12px;
    border-bottom: 1px solid #e0e0e0;
  }
  .custom-table td {
    box-sizing: border-box;
    height: 45px !important;
    font-family: Titillium Web;
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    color: #535e63;
    border-bottom: 1px solid #e0e0e0;
    padding-left: 8px;
  }
   
  .date-cell {
    height: 32px;
    width: 96px;
  }
  .sellable-cell {
    height: 32px;
    width: 60px;
  }
  .empty {
    height: 32px;
    width: 60px;
  }
  .expiry-date {
    height: 32px;
    width: 92px;
  }
  .unsellable-cell {
    height: 32px;
    width: 69px;
  }
  .action-cell {
    height: 32px;
    width: 50px;
  }
  .case-pack-cell {
    width: 70px;
    padding-left: 8px;
    border-left: 1px solid #eceff1;
    vertical-align: middle; /* Center vertically */
  }
  span {
    display: block;
    font-family: Titillium Web;
    color: #535e63;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
  }
  small {
    font-family: Titillium Web;
    color: #535e63;
    font-weight: 400;
    font-size: 9px;
    line-height: 12px;
  }
  .loose-pack-cell {
    width: 181px !important;
    padding-left: 8px;
    vertical-align: middle; /* Center vertically */
    span {
      display: block;
      font-family: Titillium Web;
      color: #535e63;
      font-weight: 400;
      font-size: 14px;
      line-height: 16px;
    }
    small {
      font-family: Titillium Web;
      color: #535e63;
      font-weight: 400;
      font-size: 9px;
      line-height: 12px;
    }
  }

  .delete-icon {
    cursor: pointer;
    color: #ff4d4f;
    transition: opacity 0.2s;
    font-size: 16px;
  }

  .delete-icon:hover {
    opacity: 0.7;
  }
  .disabled-action {
    cursor: not-allowed;
  }
  .disabled-icon {
    color: #ff999a;;
    
    pointer-events: none;
  }
`;

export const DrawerWrapper = styled(Drawer)`
z-index: 0 !important;
.table-div {
    height: 250px;
    margin-top: 10px;
    width: 488px;
  }
  .ant-drawer-content {
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
  }

  .ant-drawer-close {
    display: none;
  }

  .ant-drawer-body {
    padding: 22px;
  }

  // Common classes
  .blue-span {
    font-family: inherit;
    font-weight: 700;
    font-size: 18px;
    line-height: 30px;
    color: #1565df;
  }
  .simple-button {
    all: unset;
    display: inline-flex;
    width: 64px;
    justify-content: center;
    align-items: center;
  }

  // Common classes

  .upper-div {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 620px;

    .receive-product {
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 149px;
      height: 30px;
      color: #1565d8;
      font-size: 18px;
      line-height: 30px;
      font-weight: 700;
      font-family: Titillium Web;

      .arrow-icon {
        display: flex;
        align-items: center; 
        justify-content: center;
        height: 16px;
        width: 16px;

        img {
          height: 10px;
          width: 12px;
          object-fit: contain;
        }
      }
    }
      .receive-product:hover{ 
      cursor:pointer;
      }

    .product {
      display: inline-flex;
      height: 101px;
      width: 488px;
      border-bottom: 1px solid #D9D9D9;
      .image-div {
        display: flex;
        height: 88px;
        width: 487px;
        .image-container {
            display: flex;
            img {
                  border-radius: 2px;
                  min-width: 88px !important;
                  min-height: 88px !important;
                  max-width: 88px !important;
                  max-height: 88px !important;
                  object-fit: contain;
                }
         }
    .content-div{
      padding-left: 8px;
      display: flex;
      flex-direction: column;
      width: 100%;
      .quantity-section{
        height: 100%;
        display: flex;
        justify-content: space-between;
        .section-items{
          display: flex;
          flex-direction: column;
          justify-content: space-around;
        }
      }
      .heading-text {
          font-size: 12px;
          font-weight: 400;
          color: #7e8a90;
          line-height: 16px;
        }
        .value-text {
          font-size: 14px;
          font-weight: 600;
          color: #4e5969;
          line-height: 18px;
          text-align: left;
          width: 100%;
        }
    }
      }
      

      .quantity-div {
        display: flex;
        flex-direction: column;
        height: 38px;
        width: 58px;
        margin-top: 20px;
      }
        .received-div{
        width:66px !important;
        }
    }
    .sellable {
      height: 102px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .sellable-top {
        display: flex;
        justify-content: space-between;
        .loose-pack-button{
          border-top-left-radius: 2px;
          border-bottom-left-radius: 2px;
        }
        .case-pack-button{
          border-top-right-radius: 2px;
          border-bottom-right-radius: 2px;
        }
        .contained {
          margin-right: 5px;
          height: 20px;
          background: #1565d8;
          color: white;
          border: none;
          cursor: pointer;
          font-size: 12px;
          font-family: inherit;
          transition: background 0.3s ease;
        }
        .outlined {
          margin-right: 5px;
          height: 18px;
          background: transparent;
          color: #1565d8;

          border: 1px solid #1565d8;
          cursor: pointer;
          font-size: 12px;
          font-weight: 400;
          line-height: 12px;
          font-family: inherit;
          transition: background 0.3s ease, border-color 0.3s ease;
        }
      }
      .sellable-bottom {
        .input-section {
          display: flex;
          justify-content: space-between;
          .loose-pack-divs {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: 232px;
            height: 56px;
            span {
              color: #515151;
              line-height: 16px;
              font-family: Titillium Web;
              font-size: 12px;
              font-weight: 400;
            }
          }
        }
        .case-pack {
          display: flex;
          justify-content: space-between;
          .input-divs {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: 144px;
            height: 56px;
            span {
              color: #515151;
              line-height: 16px;
              font-family: Titillium Web;
              font-size: 12px;
              font-weight: 400;
            }
          }
        }
      }
    }
    .unsellable {
      height: 102px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .input-section {
        display: flex;
        justify-content: space-between;
        .loose-pack-divs {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          width: 232px;
          height: 56px;
          span {
            color: #515151;
            line-height: 16px;
            font-family: Titillium Web;
            font-size: 12px;
            font-weight: 400;
          }
        }
      }
    }
    .file-input {
      border: 1px solid #e0e0e0;
      border-radius: 10px;
      height: 175px;
      margin: 10px 0;
      display: flex;
      flex-direction: column;
      padding: 8px 16px; /* Add padding for spacing */

      span {
        margin-bottom: 10px;
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        color: #515151;
      }

      .uploaded-file-container {
        display: flex;
        flex-direction: column;
        grid-row-gap: 8px;
        max-height: 100px;
        overflow: auto;

        .uploading-content-data {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding-right: 16px;
          .title {
            display: flex;
            align-items: center;
            grid-gap: 8px;

            span {
              font-size: 14px;
              font-weight: 400;
              line-height: 18px;
              text-align: left;
              text-underline-position: from-font;
              text-decoration-skip-ink: none;
              color: ${({ theme }) => theme['body-text-color']};
              margin:0;

              svg {
                font-size: 16px;
                color: ${({ theme }) => theme['danger-hover']};
                cursor: pointer;
                margin-right: 16px;
              }
            }
          }
        }
      }
    }

    /* Updated Dragger styles */
    .custom-dragger .ant-upload {
      background: #f0f8ff;
      border-radius: 8px;
      padding: 16px;
      text-align: center;
      transition: all 0.3s ease;

      &:hover {
        border-color: #1976d2;
        background: #e8f4ff;
      }
    }

    .custom-dragger .ant-upload-text {
      color: #333;
      font-size: 14px;
      font-weight: 600;
    }

    .custom-dragger .ant-upload-icon {
      font-size: 36px;
      color: #4caf50;
      margin-bottom: 8px;
    }

    .custom-dragger .ant-upload-hint {
      font-size: 12px;
      color: #666;
    }

    .custom-dragger.ant-upload-drag-active {
      border-color: #ff9800;
      background: #fffde7;
    }

    .upload-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      grid-gap: 8px;

      p {
        font-family: Titillium Web;
        font-size: 10px;
        font-weight: 400;
        line-height: 15.21px;
        text-align: left;
        text-decoration: underline;
        margin: 0;
        color: #1565d8;
      }
    }

    .custom-dragger span.ant-upload.ant-upload-btn {
      padding: 0px;
    }
      .lower-buttons-class {
    display: flex;
    justify-content: end;
    grid-gap: 8px;
    align-items: center;
    .cancel-button{
    all: unset;                
    display: inline-flex;      
    width: 90px;              
    justify-content: center;   
    align-items: center;       
    height: 30px;             
    background: transparent;  
    color: #1565D8;            
    border: 1px solid #1565D8; 
    border-radius: 4px;        
    cursor: pointer;         
    font-size: 14px;          
    font-weight:700;
    line-height:18px;  
    font-family: inherit;    
    transition: background 0.3s ease, border-color 0.3s ease; 
    }
    .save-button{
    all: unset;          
    display: inline-flex;
    width: 90px;          
    justify-content: center;
    align-items: center;  
    height: 32px;
    background: #1565D8;  
    color: white;        
    border-radius: 4px;  
    border: none;         
    cursor: pointer;     
    font-size: 14px;  
    font-weight:700;
    line-height:18px;    
    font-family: inherit;     
    transition: background 0.3s ease; /* Optional: Add transition for hover effect */
    }
    .disabled-save-button{
      background: #cccccc; /* Gray background shade */
      color: #666666; /* Lighter gray text color */
      cursor: not-allowed; /* Indicate the button is disabled */
      pointer-events: none; /* Prevent interaction */
    }
  }
      .delete-modal-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    img {
      margin-bottom: 12px;
    }
    h3 {
     background-color:aqua;
      font-size: 24px;
      font-weight: 600;
      line-height: 32px;
      text-align: left;
      color: ${({ theme }) => theme['headingColor']};
      margin: 0;
      margin-bottom: 4px;
    }
    p {
      font-size: 14px;
      font-weight: 400;
      line-height: 18px;
      text-align: left;
      color: ${({ theme }) => theme['body-text-color']};
      margin: 0;
    }
  }
}

`


export const ModalWrapper = styled.div`
.delete-modal-wrapper{
display:flex;
flex-direction:column;
align-items: center;
justify-content:space-between;
p{
  text-align: center;
}
}
.count-text-se{
font-weight: 700;
font-size: 14px;
line-height: 18px;
letter-spacing: 0%;
color: #D95040;
display: inline-block;
margin-top: 24px;
}
&.delete-confirmation-modal-se{
  p{
    margin: 0;
  }
}
&.bulk-expiry-modal {
  h6{
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: 0%;
  color:#1F1F1F;
  margin: 0;
  margin-bottom: 32px;
  }
  span.ant-calendar-picker{
  width: 100%;
  input{
    padding: 10px 12px;
    height: 36px;
  }
  i.anticon.anticon-calendar.ant-calendar-picker-icon {
    color: #1565D8;
}
}
}
`
